module.exports = "/_next/static/images/27a9c5e38a6940ee808afd8e6dbe54da-mulher-perfil-segurando-cartao-xs@2x.jpg";